import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
} from '@angular/core';
import { TypographyComponent } from '../typography/typography.component';
import { IconComponent } from '../icon/icon.component';
import {
  IconTypes,
  IconValuesType,
} from '../icon/icon.component.types';

export type NotificationType =
  | 'default'
  | 'success'
  | 'warning'
  | 'error'
  | 'info';

@Component({
  selector: 'hyperkit-notification',
  templateUrl: './notification.component.html',
  styleUrls: ['./notification.component.scss'],
  standalone: true,
  imports: [CommonModule, TypographyComponent, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush, 
})
export class NotificationsComponent implements OnInit {
  @Input() public type: NotificationType = 'default';
  @Input() public header: string = 'Notification';
  @Input() public body: string = '';
  @Input() public closeable: boolean = true;
  @Input() public showActions: boolean = true;

  @Output() public close = new EventEmitter<void>();

  public iconClass: IconValuesType = IconTypes.Info;

  public ngOnInit(): void {
    this.iconClass = this.getIconClass();
  }

  public getIconClass(): IconValuesType {
    switch (this.type) {
      case 'success':
        return IconTypes.CheckCircle;
      case 'warning':
        return IconTypes.AlertOctagon;
      case 'error':
        return IconTypes.XOctagon;
      case 'info':
      case 'default':
        return IconTypes.Info;
      default:
        return IconTypes.Info;
    }
  }

  public onClose(): void {
    this.close.emit();
  }
}
